import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const ThemedBody = createGlobalStyle`
    ${reset}

    *,
    *:after,
    *:before {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
    }

    html {
        // AQ-1214: Workaround for iOS Safari
        min-height: -webkit-fill-available;
    }

    body {
        min-height: 100vh;
        max-width: 100vw;
        display: flex;
        flex-direction: column;
        background: ${({ theme }) => theme.colors.background.white};
        // AQ-1214: Workaround for iOS Safari
        min-height: -webkit-fill-available;

        > * {
            width: 100%;
        }
    }

    body, html, div, button { 
        /* TODO: Remove this after shipping shipping https://grover.atlassian.net/browse/AQ-659 */
        font-family: var(--font-inter);
    }
`;
